import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_67: FaireProductEntity = {
  token: "starter_collection_67",
  type: "product",
  name: "Rainbow Pop Dish Towels",
  brandName: "Atelier Saucier",
  imageUrl: "",
  priceDollars: 38,
  msrpDollars: 76,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
